<p>{{ config.message }}</p>
<mat-progress-bar
  mode="determinate"
  [value]="config.progress | async"
></mat-progress-bar>
